<template>
  <div class="faq-item">
    <div class="heading" @click="$emit('toggle')">
      <div class="question">{{ question }}</div>

      <button>
        <Component :is="expand ? MinusIcon : PlusIcon" class="icon" />
      </button>
    </div>

    <div class="answer" v-if="expand" v-html="parseMarkdown(answer)"></div>
  </div>
</template>

<script setup lang="ts">
import PlusIcon from 'app/assets/images/infoCollection/plus.svg?component'
import MinusIcon from 'app/assets/images/infoCollection/minus.svg?component'
import { parseMarkdown } from '@/utils'

defineProps<{ question: string; answer: string; expand: boolean; highlight?: string }>()
defineEmits(['toggle'])
</script>

<style lang="scss" scoped>
.faq-item {
  @include flex-column(12px);

  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    cursor: pointer;

    .question {
      font-weight: 600;
    }

    button {
      display: flex;
      flex-shrink: 0;
    }

    .icon {
      width: 16px;
      color: $grey-100;
    }
  }

  .answer:deep {
    @include markdown-display;

    a {
      color: $brand-tertiary;
    }
  }
}
</style>
